"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShimmerGap = void 0;
var Utilities_1 = require("../../../Utilities");
var ShimmerGap_base_1 = require("./ShimmerGap.base");
var ShimmerGap_styles_1 = require("./ShimmerGap.styles");
exports.ShimmerGap = Utilities_1.styled(ShimmerGap_base_1.ShimmerGapBase, ShimmerGap_styles_1.getStyles, undefined, {
    scope: 'ShimmerGap',
});
//# sourceMappingURL=ShimmerGap.js.map